import React from 'react';
import EyeIcon from '@assets/svg_main/eye-outline.svg';

interface PoshanServiceListCardProps {
    data:any,
    handleRowClick: () => void;
}


const PoshanServiceListCard = (props:PoshanServiceListCardProps) =>{
    const {data, handleRowClick } = props;
    return(
        <div className='poshan-service-list-card'>
            <span>{data.service_name}</span>
            <span>{data.last_call_date}</span>
            <EyeIcon className='list-card-eye-icon' onClick={()=>handleRowClick()} />
        </div>
    )
}


export default PoshanServiceListCard;